export default function permission() {
  const getPermissions = requestLetter => ({
    can_update: false,
    can_delete: false,
    can_send: false,
    can_review: false,
    ...(requestLetter.permissions || {}),
  })

  const canUpdate = requestLetter => getPermissions(requestLetter).can_update
  const canDelete = requestLetter => getPermissions(requestLetter).can_delete
  const canSend = requestLetter => getPermissions(requestLetter).can_send
  const canReview = requestLetter => getPermissions(requestLetter).can_review

  return {
    canUpdate,
    canDelete,
    canSend,
    canReview,
  }
}
